import image from "../icons/404.svg";
function NotFound() {
  return (
    <div className="App">
      <main className="ctn-content top-ctn">
        <div className="ctn-elt">
          <h1 className="head-title">Page Introuvable</h1>
          <img
            src={image}
            style={{
              textAlign: "center",
              margin: "0 auto",
            }}
            alt="notfound"
          />
        </div>
      </main>
    </div>
  );
}

export default NotFound;
